'use client';

import GfSizeTable from '@/components/gf/GfSizeTable/GfSizeTable';
import OptionTitle from '@/components/gf/OptionTitle/OptionTitle';
import Accordion from '@/components/ui/Accordion/Accordion';
import utilsStyles from '@/styles/modules/utils.module.scss';
import type { GfSizeTableData } from '@/types';
import { useState } from 'react';
import styles from './GfSizeTableSection.module.scss';

function GfSizeTableSection({
  sizeTableData,
  title = 'サイズ',
}: {
  sizeTableData: GfSizeTableData | null;
  title?: string;
}) {
  const [isAccordionOpen, setIsAccordionOpen] = useState<boolean>(false);

  if (!sizeTableData) return null;

  const handleTitleLinkClick = () => {
    setIsAccordionOpen(!isAccordionOpen);
  };

  const getLinkText = () => {
    return isAccordionOpen ? 'サイズ表を閉じる' : 'サイズ表を開く';
  };

  return (
    <>
      {/* タイトル部分 - PCでのみリンクを表示 */}
      <div className={utilsStyles.onlyPc}>
        <OptionTitle title={title} linkText={getLinkText()} onLinkClick={handleTitleLinkClick} />
      </div>
      {/* タイトル部分 - SPではリンクなし */}
      <div className={utilsStyles.onlySp}>
        <OptionTitle title={title} />
      </div>
      {/* SP用サイズ表*/}
      <div className={`${styles.productSizeOptionAccordion} ${utilsStyles.onlySp}`}>
        <p
          className={`${styles.productSizeOptionAccordionTitle} ${utilsStyles.textLink}`}
          onClick={handleTitleLinkClick}
        >
          {getLinkText()}
        </p>
        <Accordion isOpened={isAccordionOpen}>
          <div className={styles.sizeTableContainer}>
            <GfSizeTable sizeTableData={sizeTableData} />
          </div>
        </Accordion>
      </div>
      {/* PC用サイズ表*/}
      <div className={utilsStyles.onlyPc}>
        <Accordion isOpened={isAccordionOpen}>
          <div className={styles.sizeTableContainer}>
            <GfSizeTable sizeTableData={sizeTableData} />
          </div>
        </Accordion>
      </div>
    </>
  );
}

export default GfSizeTableSection;
